import MainForm from "./components/MainForm.js";

function App() {
  return (
    <div className="container w-2/3 md:w-75 max-w-md mx-auto">
      <MainForm />
    </div>
  );
}

export default App;
